import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { MARK_CLOSE_TICKET, MARK_CLOSE_TICKET_SUCCESS, MARK_CLOSE_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* markCloseTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* body: { ticket_id, comment } — the comment is the agent's closing remark */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/mark-close`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message || 'Ticket closed successfully'}`);
      yield put({
        type: MARK_CLOSE_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to close the ticket'}`);
      yield put({
        type: MARK_CLOSE_TICKET_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to close the ticket');
    yield put({ type: MARK_CLOSE_TICKET_ERROR, payload: error });
  }
}

export function* watchMarkCloseTicket() {
  yield takeEvery(MARK_CLOSE_TICKET, markCloseTicket);
}

function* markCloseTicketSaga() {
  yield all([fork(watchMarkCloseTicket)]);
}

export default markCloseTicketSaga;
